<template>
  <div class="page-comp-update-contract">
    <jw-modal v-model:visible="data.visible" :title="data.editAddTitle" title-align="start" width="450px" :mask-closable="false" unmount-on-close>
      <jw-form :model="data.form" label-align="left" ref="contractRef" @submit="handleSubmit">
        <jw-form-item field="name" :label="$t('姓名')" show-colon :rules="{ required: true, message: $t('请填写联系人姓名') }" :validate-trigger="['change', 'input', 'blur']" :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-input v-model="data.form.name" :placeholder="$t('请填写联系人姓名')" />
        </jw-form-item>
        <jw-form-item field="productLine" :label="$t('对接产品线')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-select :placeholder="$t('请选择对接产品线')" class="system-form-item-value" v-model="data.form.productLine" :options="data.productLineList" allow-clear allow-search multiple> </jw-select>
        </jw-form-item>
        <jw-form-item field="role" :label="$t('对接人角色')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-select v-model="data.form.role" :placeholder="$t('请选择对接人角色')" class="system-form-item-value" :options="data.roleList" allow-clear allow-search multiple> </jw-select>
        </jw-form-item>
        <jw-form-item field="posts" :label="$t('对接人职位')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-select v-model="data.form.posts" :placeholder="$t('请选择对接人职位')" class="system-form-item-value" :options="data.postsList" allow-clear allow-search> </jw-select>
        </jw-form-item>
        <jw-form-item field="dept" :label="$t('所在部门')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-select v-model="data.form.dept" :placeholder="$t('请选择所在部门')" class="system-form-item-value" :options="data.deptList" allow-clear allow-search> </jw-select>
        </jw-form-item>
        <jw-form-item field="attitude" :label="$t('对接人态度')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-select v-model="data.form.attitude" :placeholder="$t('请选择对接人态度')" class="system-form-item-value" :options="data.attitudeList" allow-clear allow-search> </jw-select>
        </jw-form-item>
        <jw-form-item field="phone" :label="$t('联系方式')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-input v-model="data.form.phone" :placeholder="$t('tips.phoneNumber')"> </jw-input>
        </jw-form-item>
        <jw-form-item field="remark" :label="$t('补充信息')" show-colon :label-col-style="{ width: '110px' }" label-col-flex="auto">
          <jw-textarea
            v-model="data.form.remark"
            :placeholder="$t('请填写补充信息')"
            allow-clear
            :auto-size="{
              minRows: 2,
              maxRows: 5
            }"
          />
        </jw-form-item>
      </jw-form>
      <template #footer>
        <jw-space>
          <jw-button @click="handleCancel">{{ $t('取消') }}</jw-button>
          <jw-button type="primary" @click="handleOk" :loading="loading">{{ $t('确定') }}</jw-button>
        </jw-space>
      </template>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { salesService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import useLoading from '@/hooks/loading';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const emits = defineEmits(['cb']);
const { loading, setLoading } = useLoading(false); //loading
const data = reactive({
  visible: false,
  editAddTitle: '',
  type: null,
  salesId: null, //业务Id(售后服务的ID)
  id: null, //编辑时需要的参数(主键ID)
  recordId: null, //编辑时需要的参数(Apaas记录id)
  productLineList: [], //产品线下拉列表
  roleList: [], //对接人角色下拉列表
  postsList: [], //对接人职位下拉列表
  deptList: [], //所在部门下拉列表
  attitudeList: [], //对接人态度下拉列表
  form: {
    name: '',
    productLine: '',
    role: '',
    posts: '',
    dept: '',
    attitude: '',
    phone: '',
    remark: ''
  }
});
const contractRef = ref(null);
// 新增/编辑客户关键联系人
const open = (params) => {
  data.visible = true;
  data.editAddTitle = params.title;
  data.type = params.type;
  data.salesId = params.salesId;
  data.productLineList = params.selectOption.productLine;
  data.attitudeList = params.selectOption.attitude;
  data.roleList = params.selectOption.role;
  data.postsList = params.selectOption.posts;
  data.deptList = params.selectOption.dept;
  console.log(84, params);
  if (params.type === 2) {
    const record = JSON.parse(JSON.stringify(params.record));
    const list = params.record.list;
    data.id = params.record.id;
    data.recordId = params.record.recordId;
    list?.map((item) => {
      record[item.fieldKey] = item.valueName;
    });
    console.log(77, record);
    data.form.name = record.name;
    data.form.productLine = record.productLine?.split(',');
    data.form.role = record.role?.split(',');
    data.form.posts = record.posts;
    data.form.dept = record.dept;
    data.form.attitude = record.attitude;
    data.form.phone = record.phone;
    data.form.remark = record.remark;
  } else {
    data.form.name = '';
    data.form.productLine = '';
    data.form.role = '';
    data.form.posts = '';
    data.form.dept = '';
    data.form.attitude = '';
    data.form.phone = '';
    data.form.remark = '';
  }
};
// 添加、编辑联系人
const updateContract = async () => {
  setLoading(true);
  // 解决组件库下拉多选时，第一个值为空字符串，用substring去掉第一个逗号
  console.log(131, data.form.productLine, data.form.productLine[0], data.form.role, data.form.role[0]);
  const productLine = data.form.productLine?.length == 0 ? '' : data.form.productLine[0] ? data.form.productLine?.join() : data.form.productLine?.join()?.substring(1);
  const role = data.form.role?.length == 0 ? '' : data.form.role[0] ? data.form.role?.join() : data.form.role?.join()?.substring(1);
  console.log(134, productLine, role);
  const params = {
    salesId: data.salesId,
    posts: data.form.posts,
    dept: data.form.dept,
    name: data.form.name,
    phone: data.form.phone,
    attitude: data.form.attitude,
    remark: data.form.remark,
    productLine,
    role,
    id: data.type === 2 ? data.id : undefined,
    recordId: data.type === 2 ? data.recordId : undefined
  };
  let fn = 'addContract';
  if (data.type === 2) {
    fn = 'updateContract';
  }
  try {
    const json = await salesService[fn](params);
    if (!json.error) {
      if (data.type === 1) {
        Message.success(t('添加成功'));
      } else {
        Message.success(t('保存成功'));
      }
      emits('cb');
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
    setLoading(false);
    data.visible = false;
  } catch (e) {
    Message.error(e.message || e.statusText || t('操作失败'));
    setLoading(false);
  }
};
// 取消
const handleCancel = () => {
  data.visible = false;
};
// 模态框的确定按钮
const handleOk = () => {
  contractRef.value.handleSubmit();
};
// 表单的提交按钮
const handleSubmit = ({ values, errors }) => {
  console.log(errors);
  console.log(values);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    contractRef.value.setFields(errorArray);
    setLoading(false);
    return;
  }
  updateContract();
};
defineExpose({ open });
</script>
<style scoped lang="less">
@import './index.less';
</style>
